var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"hidden-xs hidden-sm",attrs:{"id":"left-nav"}},_vm._l((_vm.nav),function(child,i){return _c('NavItem',{key:i,attrs:{"nav":child,"ariaID":i,"currentPageXID":_vm.currentPageXID,"serverPath":_vm.serverPath}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }